/**
 * Type predicate that will remove nil (null | undefined) values
 */
export const notNil = <TValue>(value: TValue | null | undefined): value is TValue => !(value == null);
